import { Link as LinkInit } from 'react-router';
import { Button } from 'antd';
import { COLORS } from '@/utils/static';
import styled from 'styled-components';
import { BREAKPOINTS } from '@/ui/layout';

export const ExternalLink = ({ children, external, fontSize, color, shortened, ...props }) => {
  return (
    <StyledExternalLink
      type='link'
      $external={external}
      $fontSize={fontSize}
      $color={color}
      $shortened={shortened}
      {...props}
    >
      {children}
    </StyledExternalLink>
  );
};

export const LinkButton = ({ children, ...props }) => {
  return (
    <StyledLinkButton type='link' {...props}>
      {children}
    </StyledLinkButton>
  );
};

export const Link = styled(LinkInit)`
  color: ${(p) => (p.$color ? p.$color : COLORS.blueAntd)};
  text-decoration: ${(p) => (p.$external ? 'underline' : 'none')};
`;
const StyledExternalLink = styled(Button)`
  color: ${(p) => (p.$color ? p.$color : p.$defaultColor ? COLORS.blue : COLORS.blueAntd)};
  font-size: ${(p) => (p.$fontSize ? p.$fontSize : '12px')};
  padding: 0;
  ${({ $shortened }) =>
    $shortened
      ? `display:inline-block;
        text-overflow: ellipsis;
        text-align: left;
        overflow: hidden;
        width: 200px;
        white-space: nowrap;`
      : ''}

  span {
    text-decoration: ${(p) => (p.$external ? 'underline' : 'none')};
  }
`;
export const StyledLinkButton = styled(Button)`
  color: ${COLORS.blue};
  cursor: pointer;
  font-weight: inherit;
  font-size: 16px;
  padding: 0;

  @media (max-width: ${BREAKPOINTS.smd}px) {
    font-size: 12px;
  }
`;
